import { useCallback } from 'react';

import { useResetPassword } from '@mopla/business-logic';
import { SuccessStep } from '@mopla/constants';

import { environment } from '../../../../environments/environment';
import { useWelcomePageStoreContext } from '../useWelcomePageStore';

export const useSubmitForgotPassword = () => {
	const resetPassword = useResetPassword('PASSENGER', environment.baseUrl);
	const { dispatch } = useWelcomePageStoreContext();

	const onSubmitForgotPassword = useCallback(
		async (data: { email: string }) => {
			const { email } = data;
			dispatch({ type: 'SET_FORGOT_PWD_ERROR', payload: false });
			try {
				const res = await resetPassword(email);

				if (res.status === 204) {
					dispatch({
						type: 'SET_SUCCESS_TYPE',
						payload: SuccessStep.forgotPasswordEmailSent,
					});

					return;
				}

				dispatch({ type: 'SET_FORGOT_PWD_ERROR', payload: true });
			} catch {
				dispatch({ type: 'SET_FORGOT_PWD_ERROR', payload: true });
			}
		},
		[dispatch, resetPassword]
	);

	return { onSubmitForgotPassword };
};
